export enum ServiceType {
  FixedRouteSchedule = 'fixed_route_schedule',
  PreBooking = 'pre_booking',
  RealtimeOnDemand = 'realtime_on_demand',
}
